import React from 'react';

interface ToggleOption {
  value: string;
  label: string;
}

interface MultiToggleButtonGroupProps {
  label: string;
  options: readonly ToggleOption[];
  values: string[];
  onChange: (values: string[]) => void;
}

export const MultiToggleButtonGroup: React.FC<MultiToggleButtonGroupProps> = ({
  label,
  options,
  values,
  onChange,
}) => {
  const toggleValue = (value: string) => {
    onChange(
      values.includes(value)
        ? values.filter(v => v !== value)
        : [...values, value]
    );
  };

  return (
    <div>
      <span className="text-2xs font-medium text-neutral-400 uppercase tracking-wide">{label}</span>
      <div className="flex mt-1.5 gap-1">
        {options.map(option => {
          const isSelected = values.includes(option.value);
          return (
            <button
              key={option.value}
              onClick={() => toggleValue(option.value)}
              className={`flex-1 py-1.5 text-2xs font-medium rounded-md transition-all border ${
                isSelected
                  ? 'bg-neutral-900 text-white border-neutral-900'
                  : 'bg-white text-neutral-600 border-neutral-200 hover:border-neutral-300 hover:bg-neutral-50'
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
